import { useMutation } from 'react-query';
import { queryClient } from '../../client';
import { subscribeToProduct } from './products/api';
import { purchasesKey, rentalsKey } from './products/keys';
import { Product } from './products/types';

export interface SubscribeToProductOptions {
  platformTitleId: string;
  product: Product;
}

/**
 * Subscribe to a product for a given provider. This will add the product to the user's library.
 */
export function useSubscribeToProduct() {
  return useMutation<Product, Error, SubscribeToProductOptions, unknown>({
    mutationFn: async (options: SubscribeToProductOptions) => {
      await subscribeToProduct(options.product.id, options.platformTitleId);
      return options.product;
    },
    onSuccess: (_, options) => {
      if (options.product.type === 'purchase') {
        queryClient.invalidateQueries({ queryKey: purchasesKey() });
      }

      if (options.product.type === 'rental') {
        queryClient.invalidateQueries({ queryKey: rentalsKey() });
      }
    },
  });
}
